import React, { useState, useEffect, useMemo } from 'react';
import Breadcrumbs from '../../../src/components/Breadcrumbs';
import styled from 'styled-components'
import Swal from 'sweetalert2';
import SettlementFilterDropdown from '../../components/SettlementFilterDropdown';
import Footer from '../../components/Footer';

const NegotiatorWorklist = () => {
  
  // useEffect(() => {
  //   Swal.fire({
  //       icon: "warning",
  //       title: "Reminder to all users",
  //       text: "This page is currently intended for testing only. For any concerns, please reach out to the development team.",
  //       confirmButtonColor: '#A5CC2D', 
  //     });
  // }, []);
  
  const [activeTab, setActiveTab] = useState('tab1');
  
  // Shared data state
  const [apiData, setApiData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [useApiData, setUseApiData] = useState(false);

  // Tab 1 state
  const [tab1State, setTab1State] = useState({
    selectedLegal: 'All',
    selectedClientStatus: ['All'],
    selectedNegReps: ['All'],
    selectedLegalNegotiators: ['All'],
    selectedCreditorStatus: ['All'],
    selectedOriginalCreditor: 'All',
    selectedCurrentCreditor: 'All',
    selectedOfferStatus: ['All'],
    selectedEPFStatus: 'All',
    selectedPreLegal: 'All',
    selectedIncreasingBalance: 'All',
    selectedSettlementFilter: 'All',
    useEPFPreset: false,
    epfOwedMin: '',
    epfOwedMax: '',
    selectedEPFPreset: 'All',
    isNegRepsDropdownOpen: false,
    isLegalNegotiatorsDropdownOpen: false,
    isCreditorStatusDropdownOpen: false,
    isOfferStatusDropdownOpen: false,
    isClientStatusDropdownOpen: false,
    originalCreditorSearch: '',
    currentCreditorSearch: '',
    clientIDSearch: '',
    clientNameSearch: '',
    debtIDSearch: '',
    currentPage: 1,
    itemsPerPage: 25,
    sortConfig: { key: null, direction: 'asc' },
    columnOrder: [
      'clientID', 'debtID', 'clientName', 'clientStatus', 'originalCreditor', 'originalAccount', 'currentCreditor',
      'legal', 'preLegal', 'daysDelinquent', 'creditorStatus', 'numCreditors',
      'numCreditorsNotSettled', 'settledDebts', 'negotiatorRep', 'legalNegotiator', 'referredNegotiator',
      'balanceLastUpdated', 'nextSettlementDate', 'creditorBalance', 'currentEscrowBalance', 'projectedEndOfMonthEscrowBalance',
      'projectedEOMBalance1Month', 'projectedEOMBalance2Months', 'projectedEOMBalance3Months',
      'projectedEOMBalance6Months', 'projectedEOMBalance9Months', 'projectedEOMBalance12Months',
      'projectedEOMBalance18Months', 'projectedEOMBalance24Months', 'projectedEOMBalance36Months',
      'projectedEOMBalance48Months', 'increasingBalance', 'drafting', 'draftAmount', 'settlementAmount', 'epfOwed', 'offerStatus',
    ],
    draggedColumn: null,
  });

  // Tab 2 state (duplicate)
  const [tab2State, setTab2State] = useState({
    selectedLegal: 'All',
    selectedClientStatus: ['All'],
    selectedNegReps: ['All'],
    selectedLegalNegotiators: ['All'],
    selectedCreditorStatus: ['All'],
    selectedOriginalCreditor: 'All',
    selectedCurrentCreditor: 'All',
    selectedOfferStatus: ['All'],
    selectedEPFStatus: 'All',
    selectedPreLegal: 'All',
    selectedIncreasingBalance: 'All',
    selectedSettlementFilter: 'All',
    useEPFPreset: false,
    epfOwedMin: '',
    epfOwedMax: '',
    selectedEPFPreset: 'All',
    isNegRepsDropdownOpen: false,
    isLegalNegotiatorsDropdownOpen: false,
    isCreditorStatusDropdownOpen: false,
    isOfferStatusDropdownOpen: false,
    isClientStatusDropdownOpen: false,
    originalCreditorSearch: '',
    currentCreditorSearch: '',
    clientIDSearch: '',
    clientNameSearch: '',
    debtIDSearch: '',
    currentPage: 1,
    itemsPerPage: 25,
    sortConfig: { key: null, direction: 'asc' },
    columnOrder: [
      'clientID', 'debtID', 'clientName', 'clientStatus', 'originalAccount',
      'legal', 'creditorStatus', 'numCreditors',
      'numCreditorsNotSettled', 'settledDebts', 'negotiatorRep', 'legalNegotiator', 'referredNegotiator',
      'balanceLastUpdated', 'nextSettlementDate', 'currentEscrowBalance', 'projectedEndOfMonthEscrowBalance',
      'projectedEOMBalance1Month', 'projectedEOMBalance2Months', 'projectedEOMBalance3Months',
      'projectedEOMBalance6Months', 'projectedEOMBalance9Months', 'projectedEOMBalance12Months',
      'projectedEOMBalance18Months', 'projectedEOMBalance24Months', 'projectedEOMBalance36Months',
      'projectedEOMBalance48Months', 'increasingBalance', 'drafting', 'draftAmount', 'epfOwed'
    ],
    draggedColumn: null
  });

  // Helper function to get current tab state
  const getCurrentTabState = () => {
    return activeTab === 'tab1' ? tab1State : tab2State;
  };

  // Helper function to update current tab state
  const updateCurrentTabState = (updates) => {
    console.log('Updating current tab state with:', updates);
    if (activeTab === 'tab1') {
      setTab1State(prev => ({ ...prev, ...updates }));
    } else {
      setTab2State(prev => ({ ...prev, ...updates }));
    }
  };

  // Column definitions with display names and widths
  const columnDefinitions = {
    clientID: { name: 'ClientID', width: '80px' },
    debtID: { name: 'Debt ID', width: '100px' },
    clientName: { name: 'Client Name', width: '120px' },
    clientStatus: { name: 'Client Status', width: '100px' },
    originalCreditor: { name: 'Original Creditor', width: '120px' },
    originalAccount: { name: 'Original Account', width: '120px' },
    currentCreditor: { name: 'Current Creditor', width: '120px' },
    legal: { name: 'Legal', width: '60px' },
    preLegal: { name: 'Pre-Legal', width: '80px' },
    daysDelinquent: { name: 'Days Delinquent', width: '100px' },
    creditorStatus: { name: 'Debt Status', width: '100px' },
    numCreditors: { name: '# of Creditors', width: '80px' },
    numCreditorsNotSettled: { name: '# Of creditors not Settled', width: '100px' },
    settledDebts: { name: 'Settled Debts', width: '100px' },
    negotiatorRep: { name: 'Negotiator Rep', width: '120px' },
    legalNegotiator: { name: 'Legal Negotiator', width: '120px' },
    referredNegotiator: { name: 'Referred Negotiator', width: '120px' },
    balanceLastUpdated: { name: 'Balance Last Updated', width: '120px' },
    creditorBalance: { name: 'Creditor Balance', width: '100px' },
    currentEscrowBalance: { name: 'Current Escrow Balance', width: '140px' },
    projectedEndOfMonthEscrowBalance: { name: 'Projected End of Month Escrow Balance', width: '180px' },
    projectedEOMBalance1Month: { name: 'Projected EOM Balance at 1 Month', width: '160px' },
    projectedEOMBalance2Months: { name: 'Projected EOM Balance at 2 Months', width: '160px' },
    projectedEOMBalance3Months: { name: 'Projected EOM Balance at 3 Months', width: '160px' },
    projectedEOMBalance6Months: { name: 'Projected EOM Balance at 6 Months', width: '160px' },
    projectedEOMBalance9Months: { name: 'Projected EOM Balance at 9 Months', width: '160px' },
    projectedEOMBalance12Months: { name: 'Projected EOM Balance at 12 Months', width: '160px' },
    projectedEOMBalance18Months: { name: 'Projected EOM Balance at 18 Months', width: '160px' },
    projectedEOMBalance24Months: { name: 'Projected EOM Balance at 24 Months', width: '160px' },
    projectedEOMBalance36Months: { name: 'Projected EOM Balance at 36 Months', width: '160px' },
    projectedEOMBalance48Months: { name: 'Projected EOM Balance at 48 Months', width: '160px' },
    nextSettlementDate: { name: 'Next Settlement Date', width: '120px' },
    increasingBalance: { name: 'Increasing Balance', width: '120px' },
    epfOwed: { name: 'EPF Owed', width: '100px' },
    drafting: { name: 'Drafting', width: '80px' },
    draftAmount: { name: 'Draft Amount', width: '100px' },
    settlementAmount: { name: 'Settlement Amount', width: '120px' },
    offerStatus: { name: 'Offer Status', width: '100px' }
  };

  // Fixed dropdown options
  const legalOptions = ['All', 'TRUE', 'FALSE'];
  const epfStatusOptions = ['All', 'Y', 'N'];
  const increasingBalanceOptions = ['All', 'Yes', 'No'];

  // Helper function to parse currency values
  const parseCurrencyValue = (currencyString) => {
    if (!currencyString || currencyString === '$0') return 0;
    const cleanValue = currencyString.replace(/[$,]/g, '');
    const numValue = parseFloat(cleanValue);
    return isNaN(numValue) ? 0 : numValue;
  };

  // Function to calculate if balance is increasing
  const calculateIncreasingBalance = (item) => {
    const projectedEOM = parseCurrencyValue(item.projectedEndOfMonthEscrowBalance);
    const projected3Months = parseCurrencyValue(item.projectedEOMBalance3Months);
    const projected6Months = parseCurrencyValue(item.projectedEOMBalance6Months);
    const projected12Months = parseCurrencyValue(item.projectedEOMBalance12Months);
    const projected18Months = parseCurrencyValue(item.projectedEOMBalance18Months);
    const projected24Months = parseCurrencyValue(item.projectedEOMBalance24Months);
    const projected36Months = parseCurrencyValue(item.projectedEOMBalance36Months);

    const isIncreasing = (
      projectedEOM < projected3Months &&
      projected3Months < projected6Months &&
      projected6Months < projected12Months &&
      projected12Months < projected18Months &&
      projected18Months < projected24Months &&
      projected24Months < projected36Months
    );

    return isIncreasing ? 'Yes' : 'No';
  };

  // Dynamic dropdown options based on current data
  const dropdownOptions = useMemo(() => {
    if (!useApiData || apiData.length === 0) {
      return {
        clientStatus: ['All'],
        negotiatorRep: ['All'],
        legalNegotiator: ['All'],
        creditorStatus: ['All'],
        originalCreditor: ['All'],
        currentCreditor: ['All'],
        offerStatus: ['All'],
        preLegal: ['All']
      };
    }

    const getUniqueValues = (key) => {
      const values = [...new Set(apiData.map(item => item[key]).filter(Boolean))].sort();
      return ['All', ...values];
    };

    const options = {
      clientStatus: getUniqueValues('clientStatus'),
      negotiatorRep: getUniqueValues('negotiatorRep'),
      legalNegotiator: getUniqueValues('legalNegotiator'),
      creditorStatus: getUniqueValues('creditorStatus'),
      originalCreditor: getUniqueValues('originalCreditor'),
      currentCreditor: getUniqueValues('currentCreditor'),
      offerStatus: getUniqueValues('offerStatus'),
      preLegal: getUniqueValues('preLegal')
    };
    
    console.log('Dropdown options for Legal Negotiator:', options.legalNegotiator);
    console.log('All legalNegotiator values in data:', [...new Set(apiData.map(item => item.legalNegotiator))]);
    return options;
  }, [apiData, useApiData]);

  // Load data on component mount
  useEffect(() => {
    handleSubmitData();
  }, []);

  // Click outside handler for dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      const currentState = getCurrentTabState();
      if (currentState.isNegRepsDropdownOpen && !event.target.closest('[data-dropdown="neg-reps"]')) {
        updateCurrentTabState({ isNegRepsDropdownOpen: false });
      }
      if (currentState.isLegalNegotiatorsDropdownOpen && !event.target.closest('[data-dropdown="legal-negotiators"]')) {
        updateCurrentTabState({ isLegalNegotiatorsDropdownOpen: false });
      }
      if (currentState.isCreditorStatusDropdownOpen && !event.target.closest('[data-dropdown="creditor-status"]')) {
        updateCurrentTabState({ isCreditorStatusDropdownOpen: false });
      }
      if (currentState.isOfferStatusDropdownOpen && !event.target.closest('[data-dropdown="offer-status"]')) {
        updateCurrentTabState({ isOfferStatusDropdownOpen: false });
      }
      if (currentState.isClientStatusDropdownOpen && !event.target.closest('[data-dropdown="client-status"]')) {
        updateCurrentTabState({ isClientStatusDropdownOpen: false });
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [activeTab, getCurrentTabState().isNegRepsDropdownOpen, getCurrentTabState().isLegalNegotiatorsDropdownOpen, getCurrentTabState().isCreditorStatusDropdownOpen, getCurrentTabState().isOfferStatusDropdownOpen, getCurrentTabState().isClientStatusDropdownOpen]);

  // Reset pagination when filters change
  useEffect(() => {
    updateCurrentTabState({ currentPage: 1 });
  }, [getCurrentTabState().selectedLegal, getCurrentTabState().selectedClientStatus, getCurrentTabState().selectedNegReps]);

  // Data submission handler
const handleSubmitData = async () => {

    try {
      setIsLoading(true);
      setUseApiData(false);
      
        //console.log('Sending filters:', filterData);

        // LOCAL Simulated API call - replace with actual endpoint
        //const response = await fetch('http://localhost/worklist/get_negotiations_data.php', {

        // DEV/PROD VM Database Get Data
        //const response = await fetch('./worklist/get_negotiations_data.php', {

        // PROD DATA API 
        //const response = await fetch('https://api.pacificdebt.com:14344/api/NegotiationsWorklist/GetList', {
        //method: 'GET',
        //headers: {
        //  'Content-Type': 'application/json',
        //},
        //body: JSON.stringify(filterData)
      //});

      // Fetch all pages from the API
      let allRecords = [];
      let page = 1;
      let totalPages = 1;
      const pageLimit = 10000;
      do {
          const response = await fetch(`https://nego-worklist-prod.sizzard.workers.dev/api/records?page=${page}&limit=${pageLimit}`);

          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }

          const result = await response.json();

          if (result.success && result.records) {
            allRecords = allRecords.concat(result.records);
            totalPages = result.total_pages;
            page++;
          } else {
            throw new Error('Invalid response format');
          }
        } while (page <= totalPages);

        const mappedData = allRecords.map(item => {
          const mappedItem = {
            id: item.Id,
            clientID: item.ContactId,
            debtID: item.DebtId || '',
            clientName: item.ContactName,
            clientStatus: item.ClientStatus,
            originalCreditor: item.OriginalCreditor,
            originalAccount: item.OriginalAccountNumber || '',
            currentCreditor: item.CurrentCreditor,
            legal: item.Legal ? 'TRUE' : 'FALSE',
            preLegal: item.PreLegal || 'No',
            daysDelinquent: item.DaysDelinquent || 0,
            creditorStatus: item.CreditorStatus || '',
            numCreditors: item.NumberOfCreditors || 0,
            numCreditorsNotSettled: item.NumberOfCreditorsNotSettled || 0,
            negotiatorRep: item.NegotiatorRep || '',
            legalNegotiator: item.LegalNegotiator || '',
            referredNegotiator: item.SettlementNegotiator || '',
            balanceLastUpdated: item.BalanceLastUpdated ? new Date(item.BalanceLastUpdated).toLocaleDateString() : '',
            nextSettlementDate: item.NextSettlementDate ? new Date(item.NextSettlementDate).toLocaleDateString() : '',
            creditorBalance: item.CreditorBalance ? `$${item.CreditorBalance.toLocaleString()}` : '$0',
            currentEscrowBalance: item.CurrentEscrowBalance ? `$${item.CurrentEscrowBalance.toLocaleString()}` : '$0',
            projectedEndOfMonthEscrowBalance: item.ProjectedEndOfMonth ? `$${item.ProjectedEndOfMonth.toLocaleString()}` : '$0',
            projectedEOMBalance1Month: item.ProjectedMonth1 ? `$${item.ProjectedMonth1.toLocaleString()}` : '$0',
            projectedEOMBalance2Months: item.ProjectedMonth2 ? `$${item.ProjectedMonth2.toLocaleString()}` : '$0',
            projectedEOMBalance3Months: item.ProjectedMonth3 ? `$${item.ProjectedMonth3.toLocaleString()}` : '$0',
            projectedEOMBalance6Months: item.ProjectedMonth6 ? `$${item.ProjectedMonth6.toLocaleString()}` : '$0',
            projectedEOMBalance9Months: item.ProjectedMonth9 ? `$${item.ProjectedMonth9.toLocaleString()}` : '$0',
            projectedEOMBalance12Months: item.ProjectedMonth12 ? `$${item.ProjectedMonth12.toLocaleString()}` : '$0',
            projectedEOMBalance18Months: item.ProjectedMonth18 ? `$${item.ProjectedMonth18.toLocaleString()}` : '$0',
            projectedEOMBalance24Months: item.ProjectedMonth24 ? `$${item.ProjectedMonth24.toLocaleString()}` : '$0',
            projectedEOMBalance36Months: item.ProjectedMonth36 ? `$${item.ProjectedMonth36.toLocaleString()}` : '$0',
            projectedEOMBalance48Months: item.ProjectedMonth48 ? `$${item.ProjectedMonth48.toLocaleString()}` : '$0',
            epfStatus: item.EPFOpen > 0 ? 'Y' : 'N',
            epfOwed: item.EPFOwed ? `$${item.EPFOwed.toLocaleString()}` : '$0',
            drafting: item.Drafting || '',
            draftAmount: item.DraftAmount ? `$${item.DraftAmount.toLocaleString()}` : '$0',
            settlementAmount: item.SettlementAmount ? `$${item.SettlementAmount.toLocaleString()}` : '$0',
            settledDebts: item.SettledDebts || 0,
            offerStatus: item.OfferStatus || ''
          };

          mappedItem.increasingBalance = calculateIncreasingBalance(mappedItem);
          return mappedItem;
        });
        
            setApiData(mappedData);
            setUseApiData(true);
            updateCurrentTabState({ currentPage: 1 });

            console.log(`Successfully loaded ${mappedData.length} records from database`);
    } catch (error) {
      console.error('Error fetching data:', error);
      
      // For demo purposes, create sample data
      const sampleData = Array.from({ length: 100 }, (_, index) => ({
        id: index + 1,
        clientID: `C${String(index + 1).padStart(4, '0')}`,
        debtID: `D${String(index + 1).padStart(4, '0')}`,
        clientName: `Client ${index + 1}`,
        clientStatus: ['Active', 'Inactive', 'Pending'][index % 3],
        originalCreditor: `Original Creditor ${(index % 5) + 1}`,
        currentCreditor: `Current Creditor ${(index % 5) + 1}`,
        legal: index % 2 === 0 ? 'TRUE' : 'FALSE',
        preLegal: index % 3 === 0 ? 'Yes' : 'No',
        daysDelinquent: Math.floor(Math.random() * 365),
        creditorStatus: ['Active', 'Settled', 'In Progress'][index % 3],
        numCreditors: Math.floor(Math.random() * 5) + 1,
        numCreditorsNotSettled: Math.floor(Math.random() * 3),
        settledDebts: Math.floor(Math.random() * 3),
        negotiatorRep: `Rep ${(index % 10) + 1}`,
        legalNegotiator: `Legal Negotiator ${(index % 8) + 1}`,
        referredNegotiator: `Negotiator ${(index % 5) + 1}`,
        balanceLastUpdated: new Date().toLocaleDateString(),
        nextSettlementDate: new Date(Date.now() + Math.random() * 30 * 24 * 60 * 60 * 1000).toLocaleDateString(),
        creditorBalance: `$${(Math.random() * 50000 + 10000).toLocaleString()}`,
        currentEscrowBalance: `$${(Math.random() * 20000 + 5000).toLocaleString()}`,
        projectedEndOfMonthEscrowBalance: `$${(Math.random() * 25000 + 7000).toLocaleString()}`,
        projectedEOMBalance1Month: `$${(Math.random() * 30000 + 8000).toLocaleString()}`,
        projectedEOMBalance2Months: `$${(Math.random() * 35000 + 10000).toLocaleString()}`,
        projectedEOMBalance3Months: `$${(Math.random() * 40000 + 12000).toLocaleString()}`,
        projectedEOMBalance6Months: `$${(Math.random() * 50000 + 15000).toLocaleString()}`,
        projectedEOMBalance9Months: `$${(Math.random() * 60000 + 18000).toLocaleString()}`,
        projectedEOMBalance12Months: `$${(Math.random() * 70000 + 20000).toLocaleString()}`,
        projectedEOMBalance18Months: `$${(Math.random() * 80000 + 25000).toLocaleString()}`,
        projectedEOMBalance24Months: `$${(Math.random() * 90000 + 30000).toLocaleString()}`,
        projectedEOMBalance36Months: `$${(Math.random() * 100000 + 35000).toLocaleString()}`,
        projectedEOMBalance48Months: `$${(Math.random() * 110000 + 40000).toLocaleString()}`,
        epfStatus: index % 4 === 0 ? 'Y' : 'N',
        drafting: index % 5 === 0 ? 'Yes' : 'No',
        draftAmount: `$${(Math.random() * 5000 + 1000).toLocaleString()}`,
        settlementAmount: `$${(Math.random() * 15000 + 5000).toLocaleString()}`,
        offerStatus: ['Pending', 'Accepted', 'Rejected', 'In Review'][index % 4],
        increasingBalance: 'No'
      }));

      // Calculate increasing balance for sample data
      const processedSampleData = sampleData.map(item => ({
        ...item,
        increasingBalance: calculateIncreasingBalance(item)
      }));

      setApiData(processedSampleData);
      setUseApiData(true);
      updateCurrentTabState({ currentPage: 1 });
      
      alert('Using sample data - API connection failed');
    } finally {
      setIsLoading(false);
    }
  };

  // Multi-select handlers
  const handleClientStatusChange = (value) => {
    const currentState = getCurrentTabState();
    if (value === 'All') {
      updateCurrentTabState({ selectedClientStatus: ['All'] });
    } else {
      let newSelection = [...currentState.selectedClientStatus];
      if (newSelection.includes('All')) {
        newSelection = newSelection.filter(item => item !== 'All');
      }   
      if (newSelection.includes(value)) {
        newSelection = newSelection.filter(item => item !== value);
      } else {
        newSelection.push(value);
      }    
      if (newSelection.length === 0) {
        newSelection = ['All'];
      }    
      updateCurrentTabState({ selectedClientStatus: newSelection });
    }
  };
  const handleNegRepsChange = (value) => {
    const currentState = getCurrentTabState();
    if (value === 'All') {
      updateCurrentTabState({ selectedNegReps: ['All'] });
    } else {
      let newSelection = [...currentState.selectedNegReps];
      
      if (newSelection.includes('All')) {
        newSelection = newSelection.filter(item => item !== 'All');
      }
      
      if (newSelection.includes(value)) {
        newSelection = newSelection.filter(item => item !== value);
      } else {
        newSelection.push(value);
      }
      
      if (newSelection.length === 0) {
        newSelection = ['All'];
      }
      
      updateCurrentTabState({ selectedNegReps: newSelection });
    }
  };

  const handleLegalNegotiatorsChange = (value) => {
    const currentState = getCurrentTabState();
    if (value === 'All') {
      updateCurrentTabState({ selectedLegalNegotiators: ['All'] });
    } else {
      let newSelection = [...currentState.selectedLegalNegotiators];
      
      if (newSelection.includes('All')) {
        newSelection = newSelection.filter(item => item !== 'All');
      }
      
      if (newSelection.includes(value)) {
        newSelection = newSelection.filter(item => item !== value);
      } else {
        newSelection.push(value);
      }
      
      if (newSelection.length === 0) {
        newSelection = ['All'];
      }
      
      updateCurrentTabState({ selectedLegalNegotiators: newSelection });
    }
  };

  const handleCreditorStatusChange = (value) => {
    const currentState = getCurrentTabState();
    if (value === 'All') {
      updateCurrentTabState({ selectedCreditorStatus: ['All'] });
    } else {
      let newSelection = [...currentState.selectedCreditorStatus];
      
      if (newSelection.includes('All')) {
        newSelection = newSelection.filter(item => item !== 'All');
      }
      
      if (newSelection.includes(value)) {
        newSelection = newSelection.filter(item => item !== value);
      } else {
        newSelection.push(value);
      }
      
      if (newSelection.length === 0) {
        newSelection = ['All'];
      }
      
      updateCurrentTabState({ selectedCreditorStatus: newSelection });
    }
  };

  const handleOfferStatusChange = (value) => {
    const currentState = getCurrentTabState();
    if (value === 'All') {
      updateCurrentTabState({ selectedOfferStatus: ['All'] });
    } else {
      let newSelection = [...currentState.selectedOfferStatus];
      
      if (newSelection.includes('All')) {
        newSelection = newSelection.filter(item => item !== 'All');
      }
      
      if (newSelection.includes(value)) {
        newSelection = newSelection.filter(item => item !== value);
      } else {
        newSelection.push(value);
      }
      
      if (newSelection.length === 0) {
        newSelection = ['All'];
      }
      
      updateCurrentTabState({ selectedOfferStatus: newSelection });
    }
  };

  // Sorting function
  const handleSort = (key) => {
    const currentState = getCurrentTabState();
    let direction = 'asc';
    if (currentState.sortConfig.key === key && currentState.sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    updateCurrentTabState({ 
      sortConfig: { key, direction },
      currentPage: 1 
    });
  };

  // Drag and drop handlers
  const handleDragStart = (e, columnKey) => {
    updateCurrentTabState({ draggedColumn: columnKey });
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e, targetColumnKey) => {
    e.preventDefault();
    const currentState = getCurrentTabState();
    
    if (!currentState.draggedColumn || currentState.draggedColumn === targetColumnKey) {
      updateCurrentTabState({ draggedColumn: null });
      return;
    }

    const newColumnOrder = [...currentState.columnOrder];
    const draggedIndex = newColumnOrder.indexOf(currentState.draggedColumn);
    const targetIndex = newColumnOrder.indexOf(targetColumnKey);

    newColumnOrder.splice(draggedIndex, 1);
    newColumnOrder.splice(targetIndex, 0, currentState.draggedColumn);
    
    updateCurrentTabState({ 
      columnOrder: newColumnOrder,
      draggedColumn: null 
    });
  };

  // Export function
  const handleExportToExcel = () => {
    const currentState = getCurrentTabState();
    const headers = currentState.columnOrder.map(key => columnDefinitions[key].name);

    const csvRows = [];
    csvRows.push(headers.join(','));

    const filteredData = getFilteredData();
    filteredData.forEach(item => {
      const row = currentState.columnOrder.map(key => {
        const value = item[key] || '';
        if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      });
      csvRows.push(row.join(','));
    });

    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `negotiator_worklist_${activeTab}_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Get filtered data for current tab
  const getFilteredData = () => {
    const currentState = getCurrentTabState();
    const settlementFilter = currentState.selectedSettlementFilter;
    console.log('Client ID Search:', currentState.clientIDSearch);
    console.log('Client Name Search:', currentState.clientNameSearch);
    console.log('Legal Negotiators filter:', currentState.selectedLegalNegotiators);
    console.log('Settlement Filter:', settlementFilter);
    const displayData = useApiData ? apiData : [];
    
    let filteredData = displayData.filter(item => {
      const legalMatch = (currentState.selectedLegal === 'All' || item.legal === currentState.selectedLegal);
      const epfMatch = (currentState.selectedEPFStatus === 'All' || item.epfStatus === currentState.selectedEPFStatus);
      const clientStatusMatch = currentState.selectedClientStatus.includes('All') || currentState.selectedClientStatus.includes(item.clientStatus);
      const negRepsMatch = currentState.selectedNegReps.includes('All') || currentState.selectedNegReps.includes(item.negotiatorRep);
      const legalNegotiatorsMatch = currentState.selectedLegalNegotiators.includes('All') || currentState.selectedLegalNegotiators.includes(item.legalNegotiator);
      const creditorStatusMatch = currentState.selectedCreditorStatus.includes('All') || currentState.selectedCreditorStatus.includes(item.creditorStatus);
      const originalCreditorMatch = (currentState.selectedOriginalCreditor === 'All' || item.originalCreditor === currentState.selectedOriginalCreditor);
      const currentCreditorMatch = (currentState.selectedCurrentCreditor === 'All' || item.currentCreditor === currentState.selectedCurrentCreditor);
      const offerStatusMatch = currentState.selectedOfferStatus.includes('All') || currentState.selectedOfferStatus.includes(item.offerStatus);
      const preLegalMatch = (currentState.selectedPreLegal === 'All' || item.preLegal === currentState.selectedPreLegal);
      const increasingBalanceMatch = (currentState.selectedIncreasingBalance === 'All' || item.increasingBalance === currentState.selectedIncreasingBalance);
      
      const originalCreditorSearchMatch = currentState.originalCreditorSearch === '' || 
        (item.originalCreditor && String(item.originalCreditor).toLowerCase().includes(currentState.originalCreditorSearch.toLowerCase()));
      const currentCreditorSearchMatch = currentState.currentCreditorSearch === '' || 
        (item.currentCreditor && String(item.currentCreditor).toLowerCase().includes(currentState.currentCreditorSearch.toLowerCase()));
      const clientIDSearchMatch = currentState.clientIDSearch === '' ||
        (item.clientID && String(item.clientID).toLowerCase().includes(currentState.clientIDSearch.toLowerCase()));
      const clientNameSearchMatch = currentState.clientNameSearch === '' ||
        (item.clientName && String(item.clientName).toLowerCase().includes(currentState.clientNameSearch.toLowerCase()));
      const debtIDSearchMatch = currentState.debtIDSearch === '' ||
         (item.debtID && String(item.debtID).toLowerCase().includes(currentState.debtIDSearch.toLowerCase()));

      const epfOwedMatch = () => {
        const epfValue = parseCurrencyValue(item.epfOwed);
        if (currentState.useEPFPreset) {
          if (currentState.selectedEPFPreset === 'All') return true;
          switch (currentState.selectedEPFPreset) {
            case '$0': return epfValue === 0;
            case '$100–$250': return epfValue >= 100 && epfValue <= 250;
            case '$251–$500': return epfValue >= 251 && epfValue <= 500;
            case '$501–$999': return epfValue >= 501 && epfValue <= 999;
            case '$1,000+': return epfValue >= 1000;
            default: return true;
          }
        } else {
          const min = parseFloat(currentState.epfOwedMin) || 0;
          const max = parseFloat(currentState.epfOwedMax) || Infinity;
          return epfValue >= min && epfValue <= max;
        }
      };

      const allMatches = legalMatch && epfMatch && clientStatusMatch && negRepsMatch && legalNegotiatorsMatch &&
             creditorStatusMatch && originalCreditorMatch && currentCreditorMatch && offerStatusMatch &&
             preLegalMatch && increasingBalanceMatch && epfOwedMatch() && originalCreditorSearchMatch && currentCreditorSearchMatch &&
             clientIDSearchMatch && clientNameSearchMatch && debtIDSearchMatch;
      
      // Debug logging for Legal Negotiator filter
      if (!legalNegotiatorsMatch && !currentState.selectedLegalNegotiators.includes('All')) {
        console.log('Legal Negotiator filter mismatch:', {
          itemLegalNegotiator: item.legalNegotiator,
          selectedLegalNegotiators: currentState.selectedLegalNegotiators,
          itemMatches: currentState.selectedLegalNegotiators.includes(item.legalNegotiator)
        });
      }
      
      // Settlement filter logic
      if (settlementFilter === 'First Settlement') {
        return allMatches && item.settledDebts === 0;
      } else if (settlementFilter === 'Last Settlement') {
        return allMatches && item.numCreditorsNotSettled === 1 && item.offerStatus !== 'Completed';
      }

      return allMatches; // Default case for 'All'
    });

    console.log('Filtered Data Length:', filteredData.length);
    console.log('Total Display Data Length:', displayData.length);
    if (filteredData.length === 0) {
      console.log('No data matches all filters');
      console.log('Legal Negotiator filter state:', currentState.selectedLegalNegotiators);
      console.log('Available Legal Negotiator values:', [...new Set(displayData.map(item => item.legalNegotiator).filter(Boolean))]);
    }
    
    // Apply sorting
    if (currentState.sortConfig.key) {
      filteredData = [...filteredData].sort((a, b) => {
        const aValue = a[currentState.sortConfig.key] || '';
        const bValue = b[currentState.sortConfig.key] || '';
        
        const numericColumns = ['daysDelinquent', 'numCreditors', 'numCreditorsNotSettled', 'settledDebts'];
        if (numericColumns.includes(currentState.sortConfig.key)) {
          const aNum = parseFloat(aValue) || 0;
          const bNum = parseFloat(bValue) || 0;
          return currentState.sortConfig.direction === 'asc' ? aNum - bNum : bNum - aNum;
        }
        
        const aStr = String(aValue).toLowerCase();
        const bStr = String(bValue).toLowerCase();
        
        if (aStr < bStr) return currentState.sortConfig.direction === 'asc' ? -1 : 1;
        if (aStr > bStr) return currentState.sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }

    // For Worklist 2 (tab2), show only one entry per client ID
    if (activeTab === 'tab2') {
      const seenClientIDs = new Set();
      filteredData = filteredData.filter(item => {
        if (seenClientIDs.has(item.clientID)) {
          return false;
        }
        seenClientIDs.add(item.clientID);
        return true;
      });
    }

    return filteredData;
  };

  // Multi-Select Dropdown Component
  const MultiSelectDropdown = ({ 
    label, 
    selectedValues, 
    options, 
    onChange, 
    isOpen, 
    setIsOpen, 
    dropdownKey 
  }) => (
    <div 
      style={{ display: 'flex', flexDirection: 'column', minWidth: '140px', position: 'relative' }}
      data-dropdown={dropdownKey}
    >
      <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
        {label} ({selectedValues.includes('All') ? 'All' : selectedValues.length} selected)
      </label>
      <div style={{ position: 'relative' }}>
        <div
          onClick={() => setIsOpen(!isOpen)}
          style={{
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            padding: '3px 6px',
            fontSize: '11px',
            backgroundColor: 'white',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            minHeight: '24px',
            paddingRight: '20px',
            width: '140px',
            boxSizing: 'border-box'
          }}
        >
          <span style={{ 
            overflow: 'hidden', 
            textOverflow: 'ellipsis', 
            whiteSpace: 'nowrap',
            color: selectedValues.includes('All') ? '#6b7280' : '#374151',
            flex: 1
          }}>
            {selectedValues.includes('All') 
              ? 'All Selected' 
              : selectedValues.length === 1 
                ? selectedValues[0]
                : `${selectedValues.length} selected`
            }
          </span>
          <span style={{
            fontSize: '10px',
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease',
            flexShrink: 0
          }}>
            ▼
          </span>
        </div>

        {isOpen && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            width: '140px',
            backgroundColor: 'white',
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            zIndex: 1000,
            maxHeight: '200px',
            overflowY: 'auto'
          }}>
            {options.map((option, index) => (
              <div
                key={option}
                onClick={(e) => {
                  e.stopPropagation();
                  onChange(option);
                }}
                style={{
                  padding: '8px 12px',
                  cursor: 'pointer',
                  borderBottom: index < options.length - 1 ? '1px solid #f3f4f6' : 'none',
                  backgroundColor: 'white',
                  transition: 'background-color 0.15s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f9fafb';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'white';
                }}
              >
                <div style={{
                  width: '14px',
                  height: '14px',
                  border: '1px solid #d1d5db',
                  borderRadius: '2px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: selectedValues.includes(option) ? '#2563eb' : 'white',
                  borderColor: selectedValues.includes(option) ? '#2563eb' : '#d1d5db',
                  transition: 'all 0.15s ease',
                  flexShrink: 0
                }}>
                  {selectedValues.includes(option) && (
                    <span style={{
                      color: 'white',
                      fontSize: '10px',
                      fontWeight: 'bold',
                      lineHeight: 1
                    }}>
                      ✓
                    </span>
                  )}
                </div>
                
                <span style={{
                  fontSize: '11px',
                  color: '#374151',
                  fontWeight: selectedValues.includes(option) ? '500' : '400',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  flex: 1
                }}>
                  {option}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  // Render cell content
  const renderCellContent = (item, columnKey) => {
    const value = item[columnKey] || '';
    
    switch (columnKey) {
      case 'clientName':
        return (
          <span style={{ color: '#2563eb', textDecoration: 'underline', cursor: 'pointer' }}>
            {value}
          </span>
        );
      case 'legal':
        return (
          <span style={{ color: value === 'TRUE' ? '#059669' : '#dc2626', fontWeight: '500' }}>
            {value}
          </span>
        );
      case 'preLegal':
        return (
          <span style={{ color: value === 'TRUE' || value === 'Yes' ? '#059669' : '#dc2626', fontWeight: '500' }}>
            {value}
          </span>
        );
      case 'creditorStatus':
        return (
          <span style={{
            padding: '2px 6px',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: '500',
            backgroundColor: value === 'Active' ? '#dcfce7' : value === 'Settled' ? '#dbeafe' : '#f3f4f6',
            color: value === 'Active' ? '#166534' : value === 'Settled' ? '#1e40af' : '#374151'
          }}>
            {value}
          </span>
        );
      case 'epfStatus':
        return (
          <span style={{ color: value === 'Y' ? '#059669' : '#dc2626', fontWeight: '500' }}>
            {value}
          </span>
        );
      case 'increasingBalance':
        return (
          <span style={{ 
            color: value === 'Yes' ? '#059669' : '#dc2626', 
            fontWeight: '500',
            padding: '2px 6px',
            borderRadius: '4px',
            fontSize: '11px',
            backgroundColor: value === 'Yes' ? '#dcfce7' : '#fef2f2'
          }}>
            {value}
          </span>
        );
      case 'drafting':
        return (
          <span style={{ color: value === 'Yes' ? '#059669' : '#dc2626', fontWeight: '500' }}>
            {value}
          </span>
        );
      case 'numCreditors':
      case 'numCreditorsNotSettled':
      case 'settledDebts':
        return (
          <span style={{ textAlign: 'center', display: 'block' }}>
            {value}
          </span>
        );
      case 'nextSettlementDate':
        return (
          <span style={{ fontWeight: '500' }}>
            {value}
          </span>
        );
      case 'creditorBalance':
      case 'currentEscrowBalance':
      case 'projectedEndOfMonthEscrowBalance':
      case 'projectedEOMBalance1Month':
      case 'projectedEOMBalance2Months':
      case 'projectedEOMBalance3Months':
      case 'projectedEOMBalance6Months':
      case 'projectedEOMBalance9Months':
      case 'projectedEOMBalance12Months':
      case 'projectedEOMBalance18Months':
      case 'projectedEOMBalance24Months':
      case 'projectedEOMBalance36Months':
      case 'projectedEOMBalance48Months':
      case 'draftAmount':
      case 'settlementAmount':
        return (
          <span style={{ fontWeight: '500' }}>
            {value}
          </span>
        );
      case 'clientID':
        return (
          <span style={{ fontWeight: '500' }}>
            {value}
          </span>
        );
      default:
        return value;
    }
  };

  const getSortIcon = (columnKey) => {
    const currentState = getCurrentTabState();
    if (currentState.sortConfig.key !== columnKey) {
      return ' ↕️';
    }
    return currentState.sortConfig.direction === 'asc' ? ' ↑' : ' ↓';
  };

  // Pagination functions
  const handlePageChange = (newPage) => {
    updateCurrentTabState({ currentPage: newPage });
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    updateCurrentTabState({ 
      itemsPerPage: newItemsPerPage,
      currentPage: 1 
    });
  };

  const getPageNumbers = (filteredData) => {
    const currentState = getCurrentTabState();
    const totalPages = Math.ceil(filteredData.length / currentState.itemsPerPage);
    const pageNumbers = [];
    const maxVisible = 5;
    
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const start = Math.max(1, currentState.currentPage - Math.floor(maxVisible / 2));
      const end = Math.min(totalPages, start + maxVisible - 1);
      
      if (start > 1) {
        pageNumbers.push(1);
        if (start > 2) pageNumbers.push('...');
      }
      
      for (let i = start; i <= end; i++) {
        pageNumbers.push(i);
      }
      
      if (end < totalPages) {
        if (end < totalPages - 1) pageNumbers.push('...');
        pageNumbers.push(totalPages);
      }
    }
    
    return pageNumbers;
  };

  // Render worklist content
   const renderWorklistContent = () => {
    const currentState = getCurrentTabState();
    const filteredData = getFilteredData();
    const totalPages = Math.ceil(filteredData.length / currentState.itemsPerPage);
    const startIndex = (currentState.currentPage - 1) * currentState.itemsPerPage;
    const endIndex = startIndex + currentState.itemsPerPage;
    const paginatedData = filteredData.slice(startIndex, endIndex);

    const tableStyle = {
      minWidth: '2000px',
      fontSize: '12px'
    };

    const containerStyle = {
      overflow: 'auto',
      maxHeight: '60vh',
      maxWidth: '100%',
      border: '1px solid #e5e7eb'
    };

    const headerStyle = {
      backgroundColor: '#f9fafb',
      position: 'sticky',
      top: 0,
      zIndex: 10,
      borderBottom: '1px solid #d1d5db'
    };

    const selectStyle = {
      border: '1px solid #d1d5db',
      borderRadius: '4px',
      padding: '3px 6px',
      fontSize: '11px',
      backgroundColor: 'white',
      cursor: 'pointer'
    };

    const inputStyle = {
      border: '1px solid #d1d5db',
      borderRadius: '4px',
      padding: '3px 6px',
      fontSize: '11px',
      backgroundColor: 'white',
      width: '140px',
      boxSizing: 'border-box'
    };


    return (

      <div style={{ minHeight: '50vh', backgroundColor: '#f9fafb', padding: '20px', borderRadius: '14px' }}>
          {/* START OF THEME */}
          <div style={{ width: '100%', margin: '0 auto' }}>
            
                {/* START OF <> */}
                <>
                {/* Filters section */}
                <div style={{ 
                  backgroundColor: 'white', 
                  borderRadius: '8px', 
                  border: '1px solid #e5e7eb', 
                  padding: '12px', 
                  marginBottom: '12px',
                  display: 'flex',
                  gap: '8px',
                  flexWrap: 'wrap',
                  alignItems: 'end'
                }}>
                  
                  {/* For Worklist 2, only show Client Status and Negotiator Reps filters */}
                  {activeTab === 'tab1' && (
                    <>
                    {/* START TAB OF <> */}
                      {/* Legal - Dropdown */}
                      <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
                        <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                          Legal
                        </label>
                        <select
                          value={currentState.selectedLegal}
                          onChange={(e) => updateCurrentTabState({ selectedLegal: e.target.value })}
                          style={selectStyle}
                        >
                          {legalOptions.map(option => (
                            <option key={option} value={option}>{option}</option>
                          ))}
                        </select>
                      </div>

                      {/* PreLegal - Dynamic Dropdown */}
                      <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
                        <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                          Pre-Legal
                        </label>
                        <select
                          value={currentState.selectedPreLegal}
                          onChange={(e) => updateCurrentTabState({ selectedPreLegal: e.target.value })}
                          style={selectStyle}
                        >
                          {dropdownOptions.preLegal.map(option => (
                            <option key={option} value={option}>{option}</option>
                          ))}
                        </select>
                      </div>
                    {/* END TAB OF <> */}
                    </>
                  )}

                  {/* Client Status - Multi-Select Dropdown - Always visible */}
                  <MultiSelectDropdown
                    label="Client Status"
                    selectedValues={currentState.selectedClientStatus}
                    options={dropdownOptions.clientStatus}
                    onChange={handleClientStatusChange}
                    isOpen={currentState.isClientStatusDropdownOpen}
                    setIsOpen={(isOpen) => updateCurrentTabState({ isClientStatusDropdownOpen: isOpen })}
                    dropdownKey="client-status"
                  />

                  {/* Neg Reps - Multi-Select with Checkboxes - Always visible */}
                  <MultiSelectDropdown
                    label="Negotiator Reps"
                    selectedValues={currentState.selectedNegReps}
                    options={dropdownOptions.negotiatorRep}
                    onChange={handleNegRepsChange}
                    isOpen={currentState.isNegRepsDropdownOpen}
                    setIsOpen={(isOpen) => updateCurrentTabState({ isNegRepsDropdownOpen: isOpen })}
                    dropdownKey="neg-reps"
                  />

                  {/* Legal Negotiators - Multi-Select with Checkboxes - Always visible */}
                  <MultiSelectDropdown
                    label="Legal Negotiators"
                    selectedValues={currentState.selectedLegalNegotiators}
                    options={dropdownOptions.legalNegotiator}
                    onChange={handleLegalNegotiatorsChange}
                    isOpen={currentState.isLegalNegotiatorsDropdownOpen}
                    setIsOpen={(isOpen) => updateCurrentTabState({ isLegalNegotiatorsDropdownOpen: isOpen })}
                    dropdownKey="legal-negotiators"
                  />

                  {/* Settlement Filter - Dropdown */}
                  <SettlementFilterDropdown
                    selectedFilter={currentState.selectedSettlementFilter}
                    onChange={(value) => updateCurrentTabState({ selectedSettlementFilter: value })}
                  />

                  {/* Client ID Search - Always visible */}
                  <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                      Client ID 🔍
                    </label>
                    <input
                      type="text"
                      placeholder="Search by ID..."
                      value={currentState.clientIDSearch}
                      onChange={(e) => updateCurrentTabState({ clientIDSearch: e.target.value })}
                      style={inputStyle}
                    />
                  </div>

                  {/* Client Name Search - Always visible */}
                  <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                      Client Name 🔍
                    </label>
                    <input
                      type="text"
                      placeholder="Search by name..."
                      value={currentState.clientNameSearch}
                      onChange={(e) => updateCurrentTabState({ clientNameSearch: e.target.value })}
                      style={inputStyle}
                    />
                  </div>

                  {/* Debt ID Search - Always visible */}
                  <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                      Debt ID 🔍
                    </label>
                    <input
                      type="text"
                      placeholder="Search by debt ID..."
                      value={currentState.debtIDSearch}
                      onChange={(e) => updateCurrentTabState({ debtIDSearch: e.target.value })}
                      style={inputStyle}
                    />
                  </div>

                  {/* EPF Owed Type Toggle - Always visible */}
                  <div style={{ display: 'flex', alignItems: 'center', minWidth: '140px' }}>
                    <input
                      type="checkbox"
                      id="useEPFPreset"
                      checked={currentState.useEPFPreset}
                      onChange={(e) => updateCurrentTabState({ useEPFPreset: e.target.checked })}
                    />
                    <label htmlFor="useEPFPreset" style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginLeft: '4px' }}>
                      Use Preset Buckets for EPF Owed
                    </label>
                  </div>

                  {currentState.useEPFPreset ? (
                    <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
                      <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                        EPF Owed Preset 💰
                      </label>
                      <select
                        value={currentState.selectedEPFPreset}
                        onChange={(e) => updateCurrentTabState({ selectedEPFPreset: e.target.value })}
                        style={selectStyle}
                      >
                        {['All', '$0', '$100–$250', '$251–$500', '$501–$999', '$1,000+'].map(option => (
                          <option key={option} value={option}>{option}</option>
                        ))}
                      </select>
                    </div>
                  ) : (
                    <>
                      {/* EPF Owed Min - Input */}
                      <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
                        <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                          EPF Owed Min 💰
                        </label>
                        <input
                          type="number"
                          placeholder="Min amount..."
                          value={currentState.epfOwedMin}
                          onChange={(e) => updateCurrentTabState({ epfOwedMin: e.target.value })}
                          style={inputStyle}
                        />
                      </div>

                      {/* EPF Owed Max - Input */}
                      <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
                        <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                          EPF Owed Max 💰
                        </label>
                        <input
                          type="number"
                          placeholder="Max amount..."
                          value={currentState.epfOwedMax}
                          onChange={(e) => updateCurrentTabState({ epfOwedMax: e.target.value })}
                          style={inputStyle}
                        />
                      </div>
                    </>
                  )}

                  {/* For Worklist 1, show additional filters */}
                  {activeTab === 'tab1' && (
                    <>
                      {/* Debt Status - Multi-Select */}
                      <MultiSelectDropdown
                        label="Debt Status"
                        selectedValues={currentState.selectedCreditorStatus}
                        options={dropdownOptions.creditorStatus}
                        onChange={handleCreditorStatusChange}
                        isOpen={currentState.isCreditorStatusDropdownOpen}
                        setIsOpen={(isOpen) => updateCurrentTabState({ isCreditorStatusDropdownOpen: isOpen })}
                        dropdownKey="creditor-status"
                      />

                      {/* Original Creditor Search */}
                      <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
                        <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                          Original Creditor 🔍
                        </label>
                        <input
                          type="text"
                          placeholder="Search by name..."
                          value={currentState.originalCreditorSearch}
                          onChange={(e) => updateCurrentTabState({ originalCreditorSearch: e.target.value })}
                          style={inputStyle}
                        />
                      </div>

                      {/* Current Creditor Search */}
                      <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
                        <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                          Current Creditor 🔍
                        </label>
                        <input
                          type="text"
                          placeholder="Search by name..."
                          value={currentState.currentCreditorSearch}
                          onChange={(e) => updateCurrentTabState({ currentCreditorSearch: e.target.value })}
                          style={inputStyle}
                        />
                      </div>

                      {/* Offer Status - Multi-Select */}
                      <MultiSelectDropdown
                        label="Offer Status"
                        selectedValues={currentState.selectedOfferStatus}
                        options={dropdownOptions.offerStatus}
                        onChange={handleOfferStatusChange}
                        isOpen={currentState.isOfferStatusDropdownOpen}
                        setIsOpen={(isOpen) => updateCurrentTabState({ isOfferStatusDropdownOpen: isOpen })}
                        dropdownKey="offer-status"
                      />

                      {/* EPF Status - Dropdown - HIDDEN */}
                      {/* <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
                        <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                          EPF Status
                        </label>
                        <select
                          value={currentState.selectedEPFStatus}
                          onChange={(e) => updateCurrentTabState({ selectedEPFStatus: e.target.value })}
                          style={selectStyle}
                        >
                          {epfStatusOptions.map(option => (
                            <option key={option} value={option}>{option}</option>
                          ))}
                        </select>
                      </div> */}

                      {/* Increasing Balance - Dropdown */}
                      <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
                        <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                          Increasing Balance ✨
                        </label>
                        <select
                          value={currentState.selectedIncreasingBalance}
                          onChange={(e) => updateCurrentTabState({ selectedIncreasingBalance: e.target.value })}
                          style={selectStyle}
                        >
                          {increasingBalanceOptions.map(option => (
                            <option key={option} value={option}>{option}</option>
                          ))}
                        </select>
                      </div>
                    </>
                  )}
                  {/* Submit and Export buttons */}
                  <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
                    <button
                      onClick={handleSubmitData}
                      disabled={isLoading}
                      style={{
                        backgroundColor: isLoading ? '#9ca3af' : '#2563eb',
                        color: 'white',
                        padding: '6px 12px',
                        borderRadius: '4px',
                        fontSize: '11px',
                        border: 'none',
                        cursor: isLoading ? 'not-allowed' : 'pointer'
                      }}
                    >
                      {isLoading ? 'Loading...' : 'Refresh Data'}
                    </button>
                    
                    <button
                      onClick={handleExportToExcel}
                      disabled={filteredData.length === 0}
                      style={{
                        backgroundColor: filteredData.length === 0 ? '#9ca3af' : '#059669',
                        color: 'white',
                        padding: '6px 12px',
                        borderRadius: '4px',
                        fontSize: '11px',
                        border: 'none',
                        cursor: filteredData.length === 0 ? 'not-allowed' : 'pointer'
                      }}
                    >
                      Export to Excel
                    </button>
                  </div>
                </div>

                {/* Clear Filters Button */}
                <div style={{
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  padding: '8px 12px',
                  marginBottom: '12px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  fontSize: '12px'
                }}>
                  <div style={{ color: '#6b7280' }}>
                    Active Filters: 
                    {currentState.selectedLegal !== 'All' && <span style={{ marginLeft: '4px', padding: '2px 6px', backgroundColor: '#dbeafe', borderRadius: '3px' }}>Legal: {currentState.selectedLegal}</span>}
                    {currentState.selectedPreLegal !== 'All' && <span style={{ marginLeft: '4px', padding: '2px 6px', backgroundColor: '#dbeafe', borderRadius: '3px' }}>Pre-Legal: {currentState.selectedPreLegal}</span>}
                    {!currentState.selectedClientStatus.includes('All') && <span style={{ marginLeft: '4px', padding: '2px 6px', backgroundColor: '#dbeafe', borderRadius: '3px' }}>Client: {currentState.selectedClientStatus.length}</span>}
                    {!currentState.selectedNegReps.includes('All') && <span style={{ marginLeft: '4px', padding: '2px 6px', backgroundColor: '#dbeafe', borderRadius: '3px' }}>Neg Reps: {currentState.selectedNegReps.length}</span>}
                    {!currentState.selectedCreditorStatus.includes('All') && <span style={{ marginLeft: '4px', padding: '2px 6px', backgroundColor: '#dbeafe', borderRadius: '3px' }}>Creditor Status: {currentState.selectedCreditorStatus.length}</span>}
                    {currentState.clientIDSearch && <span style={{ marginLeft: '4px', padding: '2px 6px', backgroundColor: '#dcfce7', borderRadius: '3px' }}>Client ID: "{currentState.clientIDSearch}"</span>}
                    {currentState.clientNameSearch && <span style={{ marginLeft: '4px', padding: '2px 6px', backgroundColor: '#dcfce7', borderRadius: '3px' }}>Client: "{currentState.clientNameSearch}"</span>}
                    {currentState.originalCreditorSearch && <span style={{ marginLeft: '4px', padding: '2px 6px', backgroundColor: '#dcfce7', borderRadius: '3px' }}>Orig: "{currentState.originalCreditorSearch}"</span>}
                    {currentState.currentCreditorSearch && <span style={{ marginLeft: '4px', padding: '2px 6px', backgroundColor: '#dcfce7', borderRadius: '3px' }}>Curr: "{currentState.currentCreditorSearch}"</span>}
                    {!currentState.selectedOfferStatus.includes('All') && <span style={{ marginLeft: '4px', padding: '2px 6px', backgroundColor: '#dbeafe', borderRadius: '3px' }}>Offer Status: {currentState.selectedOfferStatus.length}</span>}
                    {currentState.selectedEPFStatus !== 'All' && <span style={{ marginLeft: '4px', padding: '2px 6px', backgroundColor: '#dbeafe', borderRadius: '3px' }}>EPF: {currentState.selectedEPFStatus}</span>}
                    {currentState.selectedIncreasingBalance !== 'All' && <span style={{ marginLeft: '4px', padding: '2px 6px', backgroundColor: '#dbeafe', borderRadius: '3px' }}>Increasing: {currentState.selectedIncreasingBalance}</span>}
                    {currentState.selectedSettlementFilter !== 'All' && <span style={{ marginLeft: '4px', padding: '2px 6px', backgroundColor: '#dbeafe', borderRadius: '3px' }}>Settlement: {currentState.selectedSettlementFilter}</span>}
                    {currentState.useEPFPreset && currentState.selectedEPFPreset !== 'All' && <span style={{ marginLeft: '4px', padding: '2px 6px', backgroundColor: '#dbeafe', borderRadius: '3px' }}>EPF Preset: {currentState.selectedEPFPreset}</span>}
                    {!currentState.useEPFPreset && (currentState.epfOwedMin || currentState.epfOwedMax) && <span style={{ marginLeft: '4px', padding: '2px 6px', backgroundColor: '#dbeafe', borderRadius: '3px' }}>EPF: {currentState.epfOwedMin || '0'} - {currentState.epfOwedMax || '∞'}</span>}
                  </div>
                  <button
                    onClick={() => {
                      const resetState = {
                        selectedLegal: 'All',
                        selectedClientStatus: ['All'],
                        selectedNegReps: ['All'],
                        selectedCreditorStatus: ['All'],
                        selectedOriginalCreditor: 'All',
                        selectedCurrentCreditor: 'All',
                        selectedOfferStatus: ['All'],
                        selectedEPFStatus: 'All',
                        selectedPreLegal: 'All',
                        selectedIncreasingBalance: 'All',
                        selectedSettlementFilter: 'All',
                        originalCreditorSearch: '',
                        currentCreditorSearch: '',
                        clientIDSearch: '',
                        clientNameSearch: '',
                        debtIDSearch: '',
                        useEPFPreset: false,
                        selectedEPFPreset: 'All',
                        epfOwedMin: '',
                        epfOwedMax: ''
                      };
                      updateCurrentTabState(resetState);
                    }}
                    style={{
                      backgroundColor: '#dc2626',
                      color: 'white',
                      padding: '4px 8px',
                      borderRadius: '4px',
                      fontSize: '10px',
                      border: 'none',
                      cursor: 'pointer'
                    }}
                  >
                    Clear All Filters
                  </button>
                </div>

                {/* Pagination and Items Per Page Controls */}
                <div style={{
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  padding: '12px',
                  marginBottom: '12px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '12px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#374151' }}>
                      Show:
                    </label>
                    <select
                      value={currentState.itemsPerPage}
                      onChange={(e) => handleItemsPerPageChange(Number(e.target.value))}
                      style={{
                        ...selectStyle,
                        width: '70px'
                      }}
                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                    <span style={{ fontSize: '12px', color: '#6b7280' }}>
                      entries per page
                    </span>
                  </div>

                  <div style={{ fontSize: '12px', color: '#6b7280' }}>
                    Showing {startIndex + 1} to {Math.min(endIndex, filteredData.length)} of {filteredData.length} entries
                    {filteredData.length !== apiData.length && (
                      <span style={{ color: '#dc2626' }}> (filtered from {apiData.length} total)</span>
                    )}
                  </div>

                  {totalPages > 1 && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <button
                        onClick={() => handlePageChange(currentState.currentPage - 1)}
                        disabled={currentState.currentPage === 1}
                        style={{
                          padding: '4px 8px',
                          fontSize: '11px',
                          border: '1px solid #d1d5db',
                          borderRadius: '4px',
                          backgroundColor: currentState.currentPage === 1 ? '#f9fafb' : 'white',
                          color: currentState.currentPage === 1 ? '#9ca3af' : '#374151',
                          cursor: currentState.currentPage === 1 ? 'not-allowed' : 'pointer'
                        }}
                      >
                        Previous
                      </button>

                      {getPageNumbers(filteredData).map((pageNum, index) => (
                        <button
                          key={index}
                          onClick={() => typeof pageNum === 'number' && handlePageChange(pageNum)}
                          disabled={pageNum === '...'}
                          style={{
                            padding: '4px 8px',
                            fontSize: '11px',
                            border: '1px solid #d1d5db',
                            borderRadius: '4px',
                            backgroundColor: pageNum === currentState.currentPage ? '#2563eb' : 'white',
                            color: pageNum === currentState.currentPage ? 'white' : pageNum === '...' ? '#9ca3af' : '#374151',
                            cursor: pageNum === '...' ? 'default' : 'pointer',
                            fontWeight: pageNum === currentState.currentPage ? '500' : 'normal'
                          }}
                        >
                          {pageNum}
                        </button>
                      ))}

                      <button
                        onClick={() => handlePageChange(currentState.currentPage + 1)}
                        disabled={currentState.currentPage === totalPages}
                        style={{
                          padding: '4px 8px',
                          fontSize: '11px',
                          border: '1px solid #d1d5db',
                          borderRadius: '4px',
                          backgroundColor: currentState.currentPage === totalPages ? '#f9fafb' : 'white',
                          color: currentState.currentPage === totalPages ? '#9ca3af' : '#374151',
                          cursor: currentState.currentPage === totalPages ? 'not-allowed' : 'pointer'
                        }}
                      >
                        Next
                      </button>
                    </div>
                  )}
                </div>

                {/* Data display section */}
                <div style={{ 
                  backgroundColor: 'white', 
                  borderRadius: '8px', 
                  border: '1px solid #e5e7eb', 
                  overflow: 'hidden' 
                }}>
                  <div style={{ padding: '12px', borderBottom: '1px solid #e5e7eb' }}>
                    <h2 style={{ fontSize: '14px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {isLoading ? 'Loading from Database...' : `Results (${filteredData.length} records)`}
                      {useApiData && <span style={{ color: '#059669', fontSize: '12px', marginLeft: '8px' }}>• Data Loaded</span>}
                    </h2>
                  </div>
                  
                  {/* Scrollable table container */}
                  <div style={containerStyle}>
                    <table style={tableStyle}>
                      <thead style={headerStyle}>
                        <tr>
                          {currentState.columnOrder.map((columnKey, index) => (
                            <th
                              key={columnKey}
                              draggable
                              onDragStart={(e) => handleDragStart(e, columnKey)}
                              onDragOver={handleDragOver}
                              onDrop={(e) => handleDrop(e, columnKey)}
                              onClick={() => handleSort(columnKey)}
                              style={{
                                padding: '8px',
                                textAlign: 'left',
                                borderRight: index < currentState.columnOrder.length - 1 ? '1px solid #d1d5db' : 'none',
                                width: columnDefinitions[columnKey].width,
                                cursor: 'pointer',
                                userSelect: 'none',
                                backgroundColor: currentState.draggedColumn === columnKey ? '#e5e7eb' : '#f9fafb',
                                position: 'relative',
                                color: '#000'
                              }}
                              title="Click to sort • Drag to reorder"
                            >
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <span>{columnDefinitions[columnKey].name}</span>
                                <span style={{ fontSize: '10px', opacity: 0.7 }}>
                                  {getSortIcon(columnKey)}
                                </span>
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          <tr>
                            <td colSpan={currentState.columnOrder.length} style={{ textAlign: 'center', padding: '32px', color: '#6b7280' }}>
                              <p>Loading data from database...</p>
                              <div style={{ fontSize: '12px', marginTop: '8px' }}>
                                Connecting to database...
                              </div>
                            </td>
                          </tr>
                        ) : paginatedData.length > 0 ? (
                          paginatedData.map((item, index) => (
                            <tr key={item.id || index} style={{ borderBottom: '1px solid #e5e7eb' }}>
                              {currentState.columnOrder.map((columnKey, colIndex) => (
                                <td
                                  key={columnKey}
                                  style={{
                                    padding: '8px',
                                    borderRight: colIndex < currentState.columnOrder.length - 1 ? '1px solid #e5e7eb' : 'none',
                                    color: '#000'
                                  }}
                                >
                                  {renderCellContent(item, columnKey)}
                                </td>
                              ))}
                            </tr>
                          ))
                        ) : filteredData.length === 0 && useApiData ? (
                          <tr>
                            <td colSpan={currentState.columnOrder.length} style={{ textAlign: 'center', padding: '32px', color: '#6b7280' }}>
                              <p>No data matches the selected filters.</p>
                              <div style={{ fontSize: '12px', marginTop: '8px' }}>
                                Try adjusting your filter criteria or using the "Clear All Filters" button.
                              </div>
                              <div style={{ fontSize: '12px', marginTop: '4px', color: '#059669' }}>
                                Total records loaded from database: {apiData.length}
                              </div>
                            </td>
                          </tr>
                        ) : (
                          <tr>
                            <td colSpan={currentState.columnOrder.length} style={{ textAlign: 'center', padding: '32px', color: '#6b7280' }}>
                              <p>No data available. Click "Refresh Data" to load from database.</p>
                              <div style={{ fontSize: '12px', marginTop: '8px' }}>
                                Make sure your server is running and the database is accessible.
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Footer with pagination summary */}
                {filteredData.length > 0 && (
                  <div style={{
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    border: '1px solid #e5e7eb',
                    padding: '12px',
                    marginTop: '12px',
                    textAlign: 'center',
                    fontSize: '12px',
                    color: '#6b7280'
                  }}>
                    <strong>Enhanced Filtering Features:</strong> Multi-select for Creditor Status and Offer Status, plus search functionality for creditor names.
                    {totalPages > 1 && (
                      <span> Currently viewing page {currentState.currentPage} of {totalPages}.</span>
                    )}
                    <div style={{ marginTop: '4px', fontSize: '11px' }}>
                      Multi-Select Tip: Click checkboxes to select multiple options. Search filters support partial name matching.
                    </div>
                    <div style={{ marginTop: '4px', fontSize: '11px', color: '#059669' }}>
                      Search Functionality: Original and Current Creditor fields now support partial name searching for better usability.
                    </div>
                  </div>
                )}
                </>
                {/* END OF <> */}
          </div>
          {/* END OF THEME */}
      </div>
    );
  };
  
 return (
      <StyledNegotiatorContainer>
            <div className="app-container">
                <div className="container">
                    <h1>Negotiator Worklist</h1>
                    <Breadcrumbs />
                    <div style={{ minHeight: '100vh', backgroundColor: 'transparent', padding: '1em 0', borderRadius: '20px' }}>
                      {/* START OF THEME */}
                      <div style={{ width: '100%', margin: '0 auto' }}>
                        {/* Tab Navigation */}
                        <div style={{
                          backgroundColor: 'white',
                          borderRadius: '8px 8px 0 0',
                          border: '1px solid #e5e7eb',
                          borderBottom: 'none',
                          padding: '0',
                          marginBottom: '0',
                          display: 'flex'
                        }}>
                          <button
                            onClick={() => setActiveTab('tab1')}
                            style={{
                              padding: '12px 24px',
                              fontSize: '14px',
                              fontWeight: '500',
                              border: 'none',
                              borderRadius: '8px 0 0 0',
                              cursor: 'pointer',
                              backgroundColor: activeTab === 'tab1' ? '#2563eb' : '#f9fafb',
                              color: activeTab === 'tab1' ? 'white' : '#6b7280',
                              borderRight: '1px solid #e5e7eb',
                              transition: 'all 0.2s ease'
                            }}
                          >
                            Overview
                            {useApiData && (
                              <span style={{ 
                                marginLeft: '8px', 
                                fontSize: '12px', 
                                opacity: 0.8,
                                backgroundColor: activeTab === 'tab1' ? 'rgba(255,255,255,0.2)' : '#e5e7eb',
                                padding: '2px 6px',
                                borderRadius: '12px'
                              }}>
                                {getFilteredData().length}
                              </span>
                            )}
                          </button>
                          
                          <button
                            onClick={() => setActiveTab('tab2')}
                            style={{
                              padding: '12px 24px',
                              fontSize: '14px',
                              fontWeight: '500',
                              border: 'none',
                              borderRadius: '0 8px 0 0',
                              cursor: 'pointer',
                              backgroundColor: activeTab === 'tab2' ? '#2563eb' : '#f9fafb',
                              color: activeTab === 'tab2' ? 'white' : '#6b7280',
                              transition: 'all 0.2s ease'
                            }}
                          >
                            Client Details
                            {useApiData && (
                              <span style={{ 
                                marginLeft: '8px', 
                                fontSize: '12px', 
                                opacity: 0.8,
                                backgroundColor: activeTab === 'tab2' ? 'rgba(255,255,255,0.2)' : '#e5e7eb',
                                padding: '2px 6px',
                                borderRadius: '12px'
                              }}>
                                {activeTab === 'tab2' ? getFilteredData().length : (() => {
                                  // Calculate tab2 filtered data count when tab1 is active
                                  const tab2Data = useApiData ? apiData : [];
                                  return tab2Data.filter(item => {
                                    const legalMatch = (tab2State.selectedLegal === 'All' || item.legal === tab2State.selectedLegal);
                                    const epfMatch = (tab2State.selectedEPFStatus === 'All' || item.epfStatus === tab2State.selectedEPFStatus);
                                    const clientStatusMatch = tab2State.selectedClientStatus.includes('All') || tab2State.selectedClientStatus.includes(item.clientStatus);
                                    const negRepsMatch = tab2State.selectedNegReps.includes('All') || tab2State.selectedNegReps.includes(item.negotiatorRep);
                                    const creditorStatusMatch = tab2State.selectedCreditorStatus.includes('All') || tab2State.selectedCreditorStatus.includes(item.creditorStatus);
                                    const originalCreditorMatch = (tab2State.selectedOriginalCreditor === 'All' || item.originalCreditor === tab2State.selectedOriginalCreditor);
                                    const currentCreditorMatch = (tab2State.selectedCurrentCreditor === 'All' || item.currentCreditor === tab2State.selectedCurrentCreditor);
                                    const offerStatusMatch = tab2State.selectedOfferStatus.includes('All') || tab2State.selectedOfferStatus.includes(item.offerStatus);
                                    const preLegalMatch = (tab2State.selectedPreLegal === 'All' || item.preLegal === tab2State.selectedPreLegal);
                                    const increasingBalanceMatch = (tab2State.selectedIncreasingBalance === 'All' || item.increasingBalance === tab2State.selectedIncreasingBalance);
                                    
                                    const originalCreditorSearchMatch = tab2State.originalCreditorSearch === '' || 
                                      (item.originalCreditor && String(item.originalCreditor).toLowerCase().includes(tab2State.originalCreditorSearch.toLowerCase()));
                                    const currentCreditorSearchMatch = tab2State.currentCreditorSearch === '' || 
                                      (item.currentCreditor && String(item.currentCreditor).toLowerCase().includes(tab2State.currentCreditorSearch.toLowerCase()));
                                    
                                    return legalMatch && epfMatch && clientStatusMatch && negRepsMatch && 
                                          creditorStatusMatch && originalCreditorMatch && currentCreditorMatch && offerStatusMatch && 
                                          preLegalMatch && increasingBalanceMatch && originalCreditorSearchMatch && currentCreditorSearchMatch;
                                  }).length;
                                })()}
                              </span>
                            )}
                          </button>
                        </div>

                        {/* Tab Content */}
                        <div style={{
                          backgroundColor: 'white',
                          borderRadius: '0 0 8px 8px',
                          border: '1px solid #e5e7eb',
                          padding: '16px',
                          minHeight: '600px'
                        }}>
                          {renderWorklistContent()}
                        </div>

                        {/* Global Status Bar */}
                        <div style={{
                          backgroundColor: 'white',
                          borderRadius: '8px',
                          border: '1px solid #e5e7eb',
                          padding: '12px',
                          marginTop: '12px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          fontSize: '12px',
                          color: '#6b7280'
                        }}>
                          <div>
                            <strong>Data Status:</strong> 
                            {useApiData ? (
                              <span style={{ color: '#059669', marginLeft: '8px' }}>
                                {apiData.length} total records loaded successfully
                              </span>
                            ) : (
                              <span style={{ color: '#dc2626', marginLeft: '8px' }}>
                                No data loaded - Click "Refresh Data" to connect to database
                              </span>
                            )}
                          </div>
                          
                          <div>
                            <strong>Active Tab:</strong> 
                            <span style={{ 
                              marginLeft: '8px',
                              padding: '2px 8px',
                              backgroundColor: activeTab === 'tab1' ? '#dbeafe' : '#fef3c7',
                              borderRadius: '4px',
                              fontWeight: '500'
                            }}>
                              {activeTab === 'tab1' ? 'Worklist 1' : 'Worklist 2'}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className='custom-footer'>
                          <Footer/>
                      </div>
                    </div>
                </div>
            </div>
        </StyledNegotiatorContainer>                  
    );

};


                       
export default NegotiatorWorklist;

const StyledNegotiatorContainer = styled.div`
    .spanText {
        padding-right: 10px;
        font-size: 20px;
    }
`